import React from 'react';
import { FileText } from 'lucide-react';
import ContentGenerationService from '../common/ContentGenerationService';

const TranscriptionService = ({
  transcriptionYoutubeUrl,
  setTranscriptionYoutubeUrl,
  youtubeVideoInfo,
  setYoutubeVideoInfo,
  extractingVideoInfo,
  generatedTranscription,
  currentTranscriptionProjectId,
  isProcessing,
  handleTranscriptionProcessing,
  handleViewTranscriptionProject,
  transcriptionKnpFile,
  setTranscriptionKnpFile,
  transcriptionLanguage,
  setTranscriptionLanguage,
  user = null,
}) => {
  return (
    <ContentGenerationService
      config={{
        featureType: 'transcription',
        featureName: 'Transcription',
        icon: FileText,
        color: 'design',
        youtubeUrl: transcriptionYoutubeUrl,
        setYoutubeUrl: setTranscriptionYoutubeUrl,
        youtubeVideoInfo,
        setYoutubeVideoInfo,
        extractingVideoInfo,
        generatedContent: generatedTranscription,
        currentProjectId: currentTranscriptionProjectId,
        isProcessing,
        handleProcessing: handleTranscriptionProcessing,
        handleViewProject: handleViewTranscriptionProject,
        setShowSettingsModal: () => {},
        user,
        fetchPrompt: () => {},
        prompt: '',
        promptVersion: 1,
        promptTotalVersions: 1,
        selectedPromptVersionForUse: null,
        isEditingPrompt: false,
        editedPrompt: '',
        promptLoading: false,
        setIsEditingPrompt: () => {},
        setEditedPrompt: () => {},
        handlePromptVersionChange: () => {},
        savePrompt: async () => {},
        setSelectedPromptVersionForUse: () => {},
        fetchPromptVersion: async () => {},
        selectedPromptId: null,
        projectTypes: [
          { value: 'transcription_generation', label: 'Transcription', icon: FileText }
        ],
        defaultProjectType: 'transcription_generation',
        showComparisonOption: false,
        defaultHasVideoAsset: true,
        transcriptionKnpFile: transcriptionKnpFile ?? null,
        setTranscriptionKnpFile: setTranscriptionKnpFile ?? (() => {}),
        transcriptionLanguage: transcriptionLanguage ?? 'ko-KR',
        setTranscriptionLanguage: setTranscriptionLanguage ?? (() => {}),
      }}
    />
  );
};

export default TranscriptionService;
